<template>
  <div class="pageContol">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">考场管理</a>
          <i>></i>
          <a href="javascript:;">焊工权重</a>
        </span>
      </div>
      <div class="framePage-body">
        <div class="framePage-scroll">
          <div class="ovy-a">
            <div class="fromTitle_1">熔化焊接与热切割作业 安全操作技术 考题权重管理</div>
            <div class="fromTitle_2" v-if="tableShowHide">考题权重规则入下表所示</div>
            <div class="fromTitle_2" v-else>当前单位未设定考题权重，考题按照完全随机模式抽取</div>
            <el-button class="bgc-bv" size="small" style="margin-bottom: 10px;" @click="setWeightButton" v-if="buttonShowHide">设置权重</el-button>
            <el-table ref="multipleTable" :data="tableData" :height="tableHeight" size="small" tooltip-effect="dark"
              :header-cell-style="tableHeader" stripe v-show="tableShowHide">
              <el-table-column label="序号" align="center" type="index" :index="indexMethod" />
              <el-table-column label="考题名称" align="left" show-overflow-tooltip prop="itemName" width="400" />
              <el-table-column label="权重" align="center" show-overflow-tooltip prop="weight" width="160" />
              <el-table-column label="概率" align="center" show-overflow-tooltip prop="probability" width="120" />
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <!-- 权重设置 -->
    <el-dialog title="权重设置" :before-close="closeDialog" :visible="addCodeShow" width="800px" center>
      <div class="fromTitle_3">请在下表中调整考题权重，确认概率符合预期范围后，确认即可</div>
      <el-table ref="multipleTable" :data="tableData" size="small" tooltip-effect="dark"
        :header-cell-style="tableHeader" stripe>
        <el-table-column label="序号" align="center" type="index" :index="indexMethod" />
        <el-table-column label="考题名称" align="left" show-overflow-tooltip prop="itemName" width="400" />
        <el-table-column label="权重" align="center" show-overflow-tooltip prop="weight" width="160" >
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.weight" size="small" :precision="0" :min="0" :max="100" @change="calculateProbability(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column label="概率" align="center" show-overflow-tooltip prop="probability" width="120" />
      </el-table>
      <span slot="footer" class="dialog-footer" style="width: 100%">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button class="bgc-bv" @click="setWeight">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import List from "@/mixins/List";
export default {
  name: "practicalAssessmentSystem_systemManage_welderWeight",
  data() {
    return {
      // 按钮显示隐藏
      buttonShowHide: true,
      // 列表显示隐藏
      tableShowHide: true,
      // 权重设置弹框显示隐藏
      addCodeShow: false,
      // 基本信息
      ruleForm: {
        centerName: "", // 考点名称
        compId: "",     // 所属单位id
        address: "",    // 考点地址
      },
      companyList: [],  //企业列表
      // 基本信息 - 数据校验
      rules: {
        centerName: [
          { required: true, trigger: "change", message: "请输入考点名称" },
        ],
        compId: [
          { required: true, trigger: "change", message: "请输入所属企业" },
        ],
        address: [
          { required: true, trigger: "change", message: "请输入考点地址" },
        ],
      },
    };
  },
  mixins: [List],
  created() {
    this.getDetail();
  },
  watch: {},
  computed: {},
  mounted() { },
  methods: {
    // 获取 - 考试列表
    getDetail() {
      this.$post("/biz/bank/pa-subject-item/comp/welder/safe", {}, 3000, true, 10).then((res) => {
        if(res.data.length > 0){
          let num = 0;
          for(let i=0; i<res.data.length; i++){
            num += res.data[i].weight || 0;
          }
          for(let i=0; i<res.data.length; i++){
            res.data[i].probability = ((res.data[i].weight / num * 100) || 0).toFixed(2) + '%'
          }
          if(num>0){
            this.tableShowHide = true;
          } else {
            this.tableShowHide = false;
          }
          this.buttonShowHide = true;
        } else {
          this.buttonShowHide = false;
          this.tableShowHide = false;
        }
        this.tableData = res.data;
      });
    },
    // 设置权重
    setWeightButton() {
      this.addCodeShow = true;
    },
    // 计算概率
    calculateProbability(row) {
      let totalWeight = 0;
      for (let index = 0; index < this.tableData.length; index++) {
        const element = this.tableData[index];
        totalWeight += element.weight || 0;
      }
      for (let index = 0; index < this.tableData.length; index++) {
        const element = this.tableData[index];
        element.probability = ((element.weight / totalWeight) * 100 || 0).toFixed(2) + '%';
      }
    },
    // 关闭弹框
    closeDialog() {
      this.addCodeShow = false;
    },
    // 确定
    setWeight() {
      let itemList = [];
      for (let index = 0; index < this.tableData.length; index++) {
        const element = this.tableData[index];
        itemList.push({
          itemId: element.itemId,
          weight: element.weight
        });
      }
      this.$post("/biz/bank/pa-subject-item/comp/welder/safe/save", {itemList}, 3000, true, 10).then((res) => {
        console.log(res.data)
        this.$message.success('操作成功');
        this.addCodeShow = false;
        this.getDetail();
      });
    }
  }
};
</script>
<style lang="less" scoped>
.fromTitle_1 {
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 600;
}
.fromTitle_2 {
  color: red;
  margin-bottom: 10px;
  float: left;
  line-height: 32px;
  width: 650px;
}
.fromTitle_3 {
  color: #999999;
}
</style>